import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { all } from "redux-saga/effects";

import { AssetTableTypeEnum } from "../utils/model";
import { watchAssetsCommon } from "./common-sagas";

interface AssetsCommonState {
  viewType: AssetTableTypeEnum | undefined;
}

const initialState: AssetsCommonState = {
  viewType: undefined,
};

const slice = createSlice({
  name: "ASSETS_COMMON",
  initialState,
  reducers: {
    switchView: (state, { payload }: PayloadAction<AssetTableTypeEnum>) => {
      state.viewType = payload;
    },
  },
});

export const { name: assetsCommonType, actions: assetsCommonActions, reducer: assetsCommonReducer } = slice;

export function* rootAssetsCommonSaga() {
  yield all([watchAssetsCommon()]);
}
